export default "__VITE_ASSET__CwS9lhNy__"